import styled from '@emotion/styled'
import { ListAlt } from '@mui/icons-material'
import type { SvgIconProps } from '@mui/material/SvgIcon'
import { memo } from 'react'
import { safeObj } from '../../utilities/safe'

const ListAltRoot = styled(ListAlt)({
    width: '1.5rem',
    height: '1.5rem',
})

type TipMenuProps = Partial<SvgIconProps>

const TipMenu = memo((props?: TipMenuProps) => {
    const { children, color, fontSize, htmlColor, titleAccess, viewBox } =
        safeObj(props)
    return (
        <ListAltRoot
            data-testid="IconButton__TipMenu"
            color={color}
            css={{ color }}
            fontSize={fontSize}
            htmlColor={htmlColor}
            titleAccess={titleAccess}
            viewBox={viewBox}
            {...props}
        >
            {children}
        </ListAltRoot>
    )
})

export default TipMenu
